module.exports = __webpack_public_path__ + "static/media/hublot.3e92e21d.svg";